<script>
import { truncatePreview } from '@modules/atendimento/utils/message-formatter'
import { ICONS } from '@modules/atendimento/constants/Text'

export default {
  name: 'ChatReplyPreview',
  props: {
    senderName: {
      type: String,
      default: '',
    },
    content: {
      type: String,
      default: '',
    },
    showCancel: {
      type: Boolean,
      default: false,
    },
    compact: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      icons: ICONS,
    }
  },
  computed: {
    truncatedContent() {
      const maxLen = this.compact ? 60 : 100
      return truncatePreview(this.content, maxLen)
    },
  },
  methods: {
    onCancel() {
      this.$emit('cancel')
    },
    onClick() {
      this.$emit('scroll-to')
    },
  },
}
</script>

<template>
  <div
    data-test="reply-preview"
    class="chat-reply-preview d-flex align-center rounded"
    :class="{ 'chat-reply-preview--compact': compact }"
    @click="onClick"
  >
    <div class="chat-reply-preview__bar" />
    <div class="chat-reply-preview__content flex-grow-1 overflow-hidden">
      <div
        v-if="senderName"
        class="chat-reply-preview__sender text-caption font-weight-medium"
      >
        {{ senderName }}
      </div>
      <div
        class="chat-reply-preview__text text-caption grey--text text-truncate"
      >
        {{ truncatedContent || 'Mensagem' }}
      </div>
    </div>
    <v-btn
      v-if="showCancel"
      icon
      small
      data-test="reply-cancel"
      class="ml-2"
      aria-label="Cancelar resposta"
      @click.stop="onCancel"
    >
      <icon-svg :name="icons.close" size="12" color="#8E8E8E" />
    </v-btn>
  </div>
</template>

<style lang="sass" scoped>
.chat-reply-preview
  background-color: rgba(0, 0, 0, 0.04)
  padding: 6px 10px
  cursor: pointer
  min-height: 36px

.chat-reply-preview--compact
  padding: 4px 8px
  min-height: 28px

.chat-reply-preview__bar
  width: 3px
  min-height: 24px
  background-color: #1976d2
  border-radius: 2px
  margin-right: 8px
  flex-shrink: 0

.chat-reply-preview--compact .chat-reply-preview__bar
  min-height: 18px

.chat-reply-preview__sender
  color: #1976d2
  font-size: 11px
  line-height: 1.3

.chat-reply-preview__text
  font-size: 12px
  line-height: 1.3
</style>
